import React from 'react';

export const DrawingGuard = ({ active = false }) => {
  if (active) {
    return <div key="overlay" className="absolute inset-0 bg-white bg-opacity-60 z-50" />;
  } else {
    return null;
  }
};
